import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const GeneralTermsPage: React.FC = () => {
  return (
    <Box sx={{ width: '100%', background: '#F2F2F2' }}>
      <Container maxWidth={false} sx={{ maxWidth: '1100px', px: { xs: 2, sm: 3, md: 4 }, py: { xs: 6, sm: 8 } }}>
        <Typography sx={{ fontFamily: 'Inter', fontWeight: 800, fontSize: { xs: '28px', sm: '36px' }, color: '#1F1F1F', mb: 2 }}>
          Všeobecné obchodní podmínky (B2C)
        </Typography>
        <Typography sx={{ color: '#666', mb: 4 }}>Poslední aktualizace: {new Date().toLocaleDateString('cs-CZ')}</Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: '18px', mb: 1 }}>1. Provozovatel</Typography>
            <Typography sx={{ color: '#444' }}>
              Apertia Robotics s.r.o., IČO: 22233270<br/>
              Matěje Koštíře 269, Sedlčánky, 250 88 Čelákovice
            </Typography>
          </Box>

          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: '18px', mb: 1 }}>2. Předmět služeb</Typography>
            <Typography sx={{ color: '#444' }}>
              Provozovatel poskytuje online nástroje a obecné právní informace generované AI. 
              Služby jsou určeny koncovým spotřebitelům (B2C) pro základní orientaci v právních tématech a práci s dokumenty.
            </Typography>
          </Box>

          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: '18px', mb: 1 }}>3. Upozornění k povaze služby</Typography>
            <Typography sx={{ color: '#444' }}>
              Výstupy AI nejsou právní radou ani právním zastoupením. 
              Mohou obsahovat nepřesnosti; u důležitých záležitostí je nezbytná konzultace s kvalifikovaným advokátem. 
              Uživatel přijímá, že konečné rozhodnutí o použití výstupů činí vždy sám.
            </Typography>
          </Box>

          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: '18px', mb: 1 }}>4. Cena a platby</Typography>
            <Typography sx={{ color: '#444' }}>
              Služby jsou účtovány prostřednictvím kreditního systému. Základní převodní hodnota je <strong>1 kredit = 0,25&nbsp;Kč (včetně DPH)</strong>. Kredity se odečítají až po úspěšném dokončení příslušného úkonu.
            </Typography>
            <Box component="ul" sx={{ color: '#444', pl: 3, mt: 1, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              <Typography component="li" sx={{ fontSize: '14px', lineHeight: 1.6 }}>
                Jednorázové úkony (pay-as-you-go): <strong>právní konzultace 200 kreditů / 50&nbsp;Kč</strong>, <strong>analýza smlouvy do 20 stran 400 kreditů / 100&nbsp;Kč</strong>, <strong>generování dokumentu 240 kreditů / 60&nbsp;Kč</strong>.
              </Typography>
              <Typography component="li" sx={{ fontSize: '14px', lineHeight: 1.6 }}>
                Měsíční tarify: <strong>START 499&nbsp;Kč / 580 kreditů</strong>, <strong>STANDARD 1 299&nbsp;Kč / 1 600 kreditů</strong>, <strong>PRO 3 299&nbsp;Kč / 4 300 kreditů</strong>. Tarify poskytují zvýhodněnou jednotkovou cenu za kredit.
              </Typography>
              <Typography component="li" sx={{ fontSize: '14px', lineHeight: 1.6 }}>
                Individuální tarif: <strong>CUSTOM</strong> – cena i kreditní rámec se stanovují na míru po konzultaci s naší obchodní ředitelkou.
              </Typography>
              <Typography component="li" sx={{ fontSize: '14px', lineHeight: 1.6 }}>
                Překročí-li uživatel měsíční limit, může dokoupit dodatečné kredity za <strong>9&nbsp;Kč / kredit</strong> (včetně DPH). Kredity jsou nepřenosné a nejsou směnitelné za hotovost.
              </Typography>
            </Box>
            <Typography sx={{ color: '#444', mt: 1.5 }}>
              Nevyužité kredity z měsíčního tarifu lze převést do následujícího měsíce, nejdéle však po dobu jednoho kalendářního měsíce. Po uplynutí této lhůty kredity propadají.
            </Typography>
            <Typography sx={{ color: '#444', mt: 1 }}>
              Platby probíhají bezhotovostně prostřednictvím poskytovatele platebních služeb. Přístup ke službě je umožněn až po úspěšném připsání kreditů. Provozovatel si vyhrazuje právo ceny upravit; změna bude oznámena nejméně 14 dní předem.
            </Typography>
          </Box>

          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: '18px', mb: 1 }}>5. Odstoupení a digitální obsah</Typography>
            <Typography sx={{ color: '#444' }}>
              U služeb poskytovaných jako digitální obsah může být plnění zahájeno před uplynutím zákonné lhůty pro odstoupení, 
              pokud s tím uživatel souhlasí. V takovém případě může být právo na odstoupení omezeno podle platných právních předpisů.
            </Typography>
          </Box>

          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: '18px', mb: 1 }}>6. Reklamace</Typography>
            <Typography sx={{ color: '#444' }}>
              Případné podněty či reklamace můžete zaslat na <a href="mailto:info@pravnibot.cz">info@pravnibot.cz</a>. 
              Reklamace vyřizujeme bez zbytečného odkladu dle povahy služby.
            </Typography>
          </Box>

          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: '18px', mb: 1 }}>7. Odpovědnost a omezení</Typography>
            <Typography sx={{ color: '#444' }}>
              Provozovatel neodpovídá za následné škody způsobené spoléháním se na AI výstupy. 
              Služba je informačního charakteru a nenahrazuje individuální právní poradenství. 
              Vždy doporučujeme ověření informací a u zásadních situací konzultaci s advokátem.
            </Typography>
          </Box>

          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: '18px', mb: 1 }}>8. Závěrečná ustanovení</Typography>
            <Typography sx={{ color: '#444' }}>
              Tyto VOP se řídí právním řádem České republiky. Případné spory lze řešit mimosoudně, například prostřednictvím ČOI, 
              nebo u věcně a místně příslušného soudu v ČR.
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default GeneralTermsPage;
